import { DateTime } from "luxon";

const generateCurrentHourIntervals = (timezone) => {
  const intervals = ["NOW"]; // Add the "NOW" option
  
  // Get the current hour and set minutes and seconds to 0
  const now = DateTime.now().setZone(timezone)

  // Round up to the next 15-minute mark
  const nextQuarterHour = now.plus({ minutes: 15 - (now.minute % 15) }).set({ second: 0, millisecond: 0 });

  // Generate 15-minute intervals starting from the next quarter-hour
  for (let i = 0; i < 4; i++) {
    const time = nextQuarterHour.plus({ minutes: i * 15 });
    intervals.push(time.toFormat("H:mm")); 
  }

  return intervals;
};

export { generateCurrentHourIntervals };